import {maintenanceApi} from '../api/maintenanceApi';
import {MaintenanceConfig, MaintenanceModeRepository} from '../../domain/MaintenanceModeRepository';
import {Country} from '@domain/model/Site/Locale';
import {TradeName} from '@domain/model/Config/Configuration';

export const ApiMaintenanceModeRepository: MaintenanceModeRepository = {
  getMaintenanceConfig: async (): Promise<MaintenanceConfig> => {
    const response = await maintenanceApi.getMaintenanceConfig();
    return {
      enabled: response.enabled,
      countries: (response.countries as unknown as Country[]) || [],
      tradenames: (response.tradenames as unknown as TradeName[]) || [],
      additionalCriteria: response.additionalCriteria,
    };
  },
};
